import type { ColumnDef } from '@tanstack/react-table';

import { type GetRitualsQuery, RitualState } from 'data/__generated__';
import { textColumn, multiSelectColumn } from 'components/DataTable';

import { DAYS_OF_THE_WEEK } from 'constants/dateAndTime';

import { formatDateForDisplay } from 'helpers/dateTimes';

import { TotemImage } from 'components/TotemImage';
import { StatusTag } from '../components/StatusTag';
import { RITUALS_STATES_LABELS } from './states';

export type RitualRow = GetRitualsQuery['rituals'][number];

type RitualFilterInput = {
    searchValue: string;
    state: RitualState[];
};

export const ritualsColumns: ColumnDef<RitualRow, unknown>[] = [
    textColumn<RitualRow, RitualFilterInput>({
        accessorKey: 'imageUrl',
        header: 'Photo',
        defaultVisible: true,
        cell: ({ row }) => <TotemImage src={row.original.imageUrl} alt={row.original.name} size={100} />,
    }),
    textColumn<RitualRow, RitualFilterInput>({
        accessorKey: 'name',
        header: 'Nom',
        defaultVisible: true,
    }),
    textColumn<RitualRow, RitualFilterInput>({
        id: 'timeWindow',
        header: 'Horaires',
        defaultVisible: true,
        accessorFn: (row) => `${row.timeWindow.start} - ${row.timeWindow.end}`,
    }),
    textColumn<RitualRow, RitualFilterInput>({
        id: 'recurrence',
        header: 'Récurrence',
        defaultVisible: true,
        accessorFn: (row) =>
            (row.activeDate ? formatDateForDisplay(row.activeDate) : '') ||
            row.activeWeekdays
                ?.slice(0, 5)
                .map((day, index) => (day ? DAYS_OF_THE_WEEK[index].label[0] : '-'))
                .join(' | ') ||
            '',
    }),
    multiSelectColumn<RitualRow, RitualFilterInput>({
        accessorKey: 'state',
        header: 'Statut',
        filterKey: 'state',
        defaultVisible: true,
        defaultFilterValue: [RitualState.Regular, RitualState.Created],
        options: Object.values(RitualState).map((state) => ({
            value: state,
            label: RITUALS_STATES_LABELS[state],
        })),
        renderOption: (option) => <StatusTag state={option.value as RitualState} />,
        cell: ({ row }) => <StatusTag state={row.original.state} />,
    }),
];
